import { Link } from "@tanstack/react-router"

import LogoWithText from "../logo-with-text"

export function CompanyHeader({
  name,
  updatedAt,
}: {
  name: string
  updatedAt: string | null
}) {
  const formattedDate = updatedAt
    ? new Date(updatedAt)
        .toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
        .toUpperCase()
    : null

  return (
    <header className="border-b">
      <div className="mx-auto flex max-w-screen-xl items-center">
        {/* Logo and Report ID */}
        <div className="flex items-center gap-2 sm:gap-4 md:gap-6">
          <Link to="/" className="brand-dark px-3 py-2 sm:px-6">
            <LogoWithText />
          </Link>

          <div className="wb-label-muted flex items-center gap-1">
            <h1 className="">{name} reviews</h1>{" "}
            <span className="hidden lg:inline">
              {formattedDate && `• updated ${formattedDate}`}
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}
